const GENERIC_KEY = "Common:amendment.errors.generic";

interface ErrorBody {
  error?: unknown;
  detail?: unknown;
  effective_date?: unknown;
}

function readBody(error: unknown): ErrorBody {
  const data = (error as { data?: unknown } | null | undefined)?.data;
  return typeof data === "object" && data !== null ? (data as ErrorBody) : {};
}

function readText(value: unknown): string {
  return typeof value === "string" ? value : "";
}

export function getAmendmentErrorKey(error: unknown, fallbackKey: string = GENERIC_KEY): string {
  const body = readBody(error);
  const text = `${readText(body.error)} ${readText(body.detail)}`;

  if (Array.isArray(body.effective_date)) return "Common:amendment.errors.effectiveDate";
  if (text.includes("job_position_ru and job_position_kk")) return "Common:amendment.errors.positionRequired";
  if (text.includes("job_duties_ru and job_duties_kk")) return "Common:amendment.errors.dutiesRequired";
  if (text.includes("salary_amount must be a number between")) return "Common:amendment.errors.salaryRange";
  if (text.includes("salary_amount must be a whole number")) return "Common:amendment.errors.salaryWholeTenge";
  if (text.includes("salary_amount")) return "Common:amendment.errors.salaryInvalid";
  if (text.includes("unfilled placeholders")) return "Common:amendment.errors.clauseUnavailable";
  if (text.includes("new_clause_text_ru")) return "Common:amendment.errors.clauseTextRequired";
  return fallbackKey;
}
